import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./features/home/home.routes').then((m) => m.HOME_ROUTES)
  },
  {
    path: 'ramen',
    loadChildren: () => import('./features/ramen/ramen.routes').then((m) => m.RAMEN_ROUTES)
  },
  {
    path: 'about',
    loadChildren: () => import('./features/about/about.routes').then((m) => m.ABOUT_ROUTES)
  },
  {
    path: 'privacy',
    loadChildren: () => import('./features/privacy/privacy.routes').then((m) => m.PRIVACY_ROUTES)
  },
  {
    path: 'top-lists',
    loadChildren: () => import('./features/top-lists/top-lists.routes').then((m) => m.TOP_LIST_ROUTES)
  },
  {
    path: 'password-reset',
    loadComponent: () =>
      import('./password-reset/password-reset.component').then(
        (m) => m.PasswordResetComponent
      )
  }, {
    path: 'profile',
    loadChildren: () => import('./features/profile/profile.routes').then((m) => m.PROFILE_ROUTES)
  }, {
    path: 'settings',
    loadChildren: () => import('./features/settings/settings.routes').then((m) => m.SETTINGS_ROUTES)
  }, {
    path: 'edit-review',
    loadChildren: () => import('./features/edit-review/edit-review.routes').then((m) => m.EDIT_REVIEW_ROUTES)
  }, {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.routes').then((m) => m.AUTH_ROUTES)
  }, {
    path: 'admin',
    loadChildren: () => import('./features/admin/admin.routes').then((m) => m.ADMIN_ROUTES)
  }, {
    path: '**',
    loadChildren: () => import('./features/not-found/not-found.routes').then((m) => m.NOT_FOUND_ROUTES)
  }
];
